<!-- <p-autoComplete (onSelect)="onSelectProduct($event)" (completeMethod)="onCompleteSearchProduct($event)" field="itemNo" [minLength]="1" placeholder="Search by Item No., Barcode..." (onClear)="clearProduct($event)">
</p-autoComplete> -->



<input type="text" [disabled]="fromInventoryModule && !accountId" [(ngModel)]="searchText" placeholder="Search by Item No., Barcode..." pInputText (keydown.enter)="onCompleteSearchProduct($event)">